import { DAY_MONTH_YEAR } from '@/libs/filterDate'

const defaultThClass = 'text-[#333333] font-semibold text-[14px] mb-0 !capitalize'

export const MAX_IMAGE_WAREHOUSE_DISPLAYED = 2

export const quantityTypeOptions = [
  {
    value: 1,
    text: 'Rak',
  },
  {
    value: 2,
    text: 'Pallet',
  },
  {
    value: 3,
    text: 'Slot',
  },
  {
    value: 4,
    text: 'm³',
  },
]

export const warehouseStatusOptions = [
  {
    value: 0,
    label: 'Penuh',
  },
  {
    value: 1,
    label: 'Tersedia',
  },
]

export const fasilitasOptions = [
  { text: 'CCTV', value: 1 },
  { text: 'Cold Storage', value: 2 },
  { text: 'APAR', value: 3 },
  { text: 'Asuransi', value: 4 },
  { text: 'Forklift', value: 5 },
  { text: 'Security', value: 6 },
  { text: 'Conveyor', value: 7 },
  { text: 'Customer Service', value: 8 },
]

export const dayOptions = [
  {
    value: 0,
    label: 'Pilih Hari Cut Off Time',
    disabled: true,
  },
  {
    value: 1,
    label: 'Senin',
  },
  {
    value: 2,
    label: 'Selasa',
  },
  {
    value: 3,
    label: 'Rabu',
  },
  {
    value: 4,
    label: 'Kamis',
  },
  {
    value: 5,
    label: 'Jumat',
  },
  {
    value: 6,
    label: 'Sabtu',
  },
  {
    value: 7,
    label: 'Minggu',
  },
]

export const dayMapping = {
  1: 'Senin',
  2: 'Selasa',
  3: 'Rabu',
  4: 'Kamis',
  5: 'Jumat',
  6: 'Sabtu',
  7: 'Minggu',
}

export const fieldsCutOfTime = [
  {
    key: 'day',
    label: 'Hari',
    thClass: defaultThClass,
    formatter: value => (dayMapping[value] ? dayMapping[value] : '-'),
  },
  {
    key: 'inbound_hour',
    label: 'Inbound',
    thClass: defaultThClass,
    formatter: value => (value ? value.split(':').slice(0, 2).join(':') : '-'),
  },
  {
    key: 'outbound_hour',
    label: 'Outbound',
    thClass: defaultThClass,
    formatter: value => (value ? value.split(':').slice(0, 2).join(':') : '-'),
  },
  {
    key: 'id',
    label: 'Action',
    thClass: defaultThClass,
  },
]

export const fieldsHariLibur = [
  {
    key: 'date',
    label: 'Hari Libur',
    thClass: defaultThClass,
    formatter: value => (value ? DAY_MONTH_YEAR(value) : '-'),
  },
  {
    key: 'memo',
    label: 'Catatan',
    tdClass: 'max-w-[260px]',
    thClass: defaultThClass,
  },
  {
    key: 'id',
    label: 'Action',
    thClass: defaultThClass,
  },
]
